const TOKEN_KEY = 'auth_token';
const REMEMBER_KEY = 'auth_remember';

const getCookie = (name: string) => {
  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const [key, ...rest] = cookie.split('=');
    if (key === name) return decodeURIComponent(rest.join('='));
  }
  return null;
}

export const getToken = () => {
  return getCookie(TOKEN_KEY);
}

export const isAuthenticated = () => {
  const token = getToken();
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const now = Math.floor(Date.now() / 1000);
    return payload.exp > now;
  } catch {
    return false;
  }
}

// A session (non-"remember me") login only ever gets a session cookie for
// the token itself, so closing the browser already clears it -- this marker
// just lets the idle-timeout logic (useIdleLogout) know, on every page load,
// whether it should be enforcing the 1-hour-idle rule at all.
export const isSessionRemembered = () => {
  return getCookie(REMEMBER_KEY) === '1';
}

export const setToken = (token: string, expires?: number, remember?: boolean) => {
  const isSecure = window.location.protocol === 'https:';
  const suffix = `path=/; SameSite=Strict${isSecure ? '; Secure' : ''}`;
  // Without "remember me", both cookies are left as session cookies (no
  // max-age) so the browser itself clears them on close -- the JWT's own
  // `exp` claim (checked in isAuthenticated) still caps how long the token
  // is valid for either way.
  const maxAge = remember && expires ? `; max-age=${expires}` : '';

  document.cookie = `${TOKEN_KEY}=${encodeURIComponent(token)}; ${suffix}${maxAge}`;

  if (remember) {
    document.cookie = `${REMEMBER_KEY}=1; ${suffix}${maxAge}`;
  } else {
    document.cookie = `${REMEMBER_KEY}=; path=/; max-age=0`;
  }
}

export const clearToken = () => {
  document.cookie = `${TOKEN_KEY}=; path=/; max-age=0`;
  document.cookie = `${REMEMBER_KEY}=; path=/; max-age=0`;
}
